import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environment';
import { NotificationBar } from 'src/services/notification.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  isSignedIn = false;
  workspaces = 0;
  notificationBar: NotificationBar;
  workspacesDBRef: any;

  constructor(private fireAuth: AngularFireAuth, private title: Title, private db: AngularFireDatabase, private snackBar: MatSnackBar) {
    this.notificationBar = new NotificationBar(snackBar);
  }

  ngOnInit() {
    this.title.setTitle("Dashboard - EsportsMS");
    this.fireAuth.onAuthStateChanged(() => {
      this.checkIfSignedIn();
    });
  }

  ngOnDestroy() {
    if (this.workspacesDBRef) {
      this.workspacesDBRef.off('value');
    };
  }

  async checkIfSignedIn() {
    var user = await (this.fireAuth.currentUser);
    if (user) {
      this.isSignedIn = true;
      this.getUserWorkspaces(user.uid);
    } 
    else {
      this.isSignedIn = false;
    }
  }

  getUserWorkspaces(userID) {
    if (this.isSignedIn == true) {
      this.workspacesDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/user/' + userID + '/workspaces/');
      this.workspacesDBRef.on('value', snapshot => {
        this.workspaces = 0;
        snapshot.forEach( userWorkspace => {
          if (userWorkspace.val() == true) {
            this.workspaces += 1;
          }
        })
      }, error => {
        this.notificationBar.showUnknownError();
      }); 
    }
  }
}
